import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import Input from "@mui/material/Input";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CircleIcon from "@mui/icons-material/Circle";

import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";

// Global variables

// Component
function Preferences(props) {
  // Hooks
  const dispatch = useDispatch();

  // Redux state
  let { noofattempts, shufflefunctionality, showanswerfunctionality } =
    useSelector((state) => state.assignment.defaults.defaults);
  let { eexam, eexamTime } = useSelector((state) => state.assignment);

  // JSX template
  return (
    <Grid container>
      <Grid item xs={6}>
        <FormGroup color="#5f5600ff" sx={{ pl: 4 }}>
          <FormControlLabel
            control={
              <Switch
                checked={eexam}
                onChange={() => {
                  dispatch(assignmentSliceActions.setEexam(!eexam));
                }}
              />
            }
            label="E-Exam"
            sx={{ color: "#5f5600ff" }}
          />
        </FormGroup>
      </Grid>
      <Grid item xs={6}>
        {!eexam && (
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showanswerfunctionality}
                  onChange={() => {
                    dispatch(
                      assignmentSliceActions.setDefaultsShowAnswer(
                        !showanswerfunctionality
                      )
                    );
                  }}
                  icon={<RadioButtonUncheckedIcon />}
                  checkedIcon={<CircleIcon />}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label="Show Answers"
              sx={{ color: "#5f5600ff" }}
            />
          </FormControl>
        )}
      </Grid>
      <Grid item xs={6}>
        {!eexam && (
          <Grid container sx={{ flexDirection: "row" }}>
            <Grid item>
              <FormControl variant="standard" sx={{ width: 40, ml: 4 }}>
                <Input
                  id="input-with-icon-adornment"
                  sx={{ textAlign: "center" }}
                  value={noofattempts}
                  onBlur={() => {
                    if (+noofattempts < 1 || +noofattempts > 9) {
                      dispatch(assignmentSliceActions.setDefaultsAttempts(3));
                    }
                  }}
                  onInput={(event) => {
                    {
                      dispatch(
                        assignmentSliceActions.setDefaultsAttempts(
                          event.target.value
                        )
                      );
                    }
                  }}
                  error={+noofattempts < 1 || +noofattempts > 9}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Typography sx={{ pt: 1, pl: 1, color: "#5f5600ff" }}>
                Attempts
              </Typography>
            </Grid>
          </Grid>
        )}
        {eexam && (
          <Grid container sx={{ flexDirection: "row" }}>
            <Grid item>
              <FormControl variant="standard" sx={{ width: 40, ml: 4 }}>
                <Input
                  id="input-with-icon-adornment"
                  sx={{ textAlign: "center" }}
                  value={eexamTime}
                  onInput={(event) => {
                    dispatch(
                      assignmentSliceActions.setEexamTime(event.target.value)
                    );
                  }}
                  onBlur={() => {
                    if (+eexamTime < 1) {
                      dispatch(assignmentSliceActions.setEexamTime(15));
                    }
                    if(+eexamTime > 60){
                      dispatch(assignmentSliceActions.setEexamTime(60));
                    }
                  }}
                  error={+eexamTime < 1 || +eexamTime > 60}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Typography sx={{ pt: 1, pl: 1, color: "#5f5600ff" }}>
                Time
              </Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
      {/* <Grid item xs={6}>
        {!eexam && (
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  checked={shufflefunctionality}
                  onChange={() => {
                    dispatch(
                      assignmentSliceActions.setDefaultsShuffleOptions(
                        !shufflefunctionality
                      )
                    );
                  }}
                  icon={<RadioButtonUncheckedIcon />}
                  checkedIcon={<CircleIcon />}
                />
              }
              label="Shuffle Options"
              sx={{ color: "#5f5600ff" }}
            />
          </FormControl>
        )}
      </Grid> */}
    </Grid>
  );
}

export default Preferences;
